import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';
import { apiBaseUrl } from '@/constants/api.js';
import store from '@/store/store';

const cacheConfig = {
  enabledByDefault: false,
  cacheFlag: 'useCache'
};

// --- API v1 Client ---
const apiClient = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: false,
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json; charset=utf-8'
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig)
});

apiClient.interceptors.request.use(
  (config) => {
    store.dispatch('loading/newRequest');
    return config;
  },
  (error) => {
    store.dispatch('loading/finishedRequest');
    return Promise.reject(error.response);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    store.dispatch('loading/finishedRequest');
    return response;
  },
  (error) => {
    store.dispatch('loading/finishedRequest');
    return Promise.reject(error);
  }
);

// --- API v2 Client ---
const apiV2Client = axios.create({
  baseURL: `${apiBaseUrl}/v2/`,
  withCredentials: false,
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json; charset=utf-8'
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig)
});

apiV2Client.interceptors.request.use(
  (config) => {
    config.headers = { 'access-token': store.getters['general/accessToken'] };
    store.dispatch('loading/newRequest');
    return config;
  },
  (error) => {
    store.dispatch('loading/finishedRequest');
    return Promise.reject(error.response);
  }
);

apiV2Client.interceptors.response.use(
  (response) => {
    store.dispatch('loading/finishedRequest');
    return response;
  },
  (error) => {
    store.dispatch('loading/finishedRequest');
    return Promise.reject(error);
  }
);

// --- API v2 - File Client ---
const apiFileClient = axios.create({
  baseURL: `${apiBaseUrl}/v2/`,
  withCredentials: false,
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'multipart/form-data'
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig)
});

apiFileClient.interceptors.request.use(
  (config) => {
    config.headers = { 'access-token': store.getters['general/accessToken'] };
    store.dispatch('loading/newRequest');
    return config;
  },
  (error) => {
    store.dispatch('loading/finishedRequest');
    return Promise.reject(error.response);
  }
);

apiFileClient.interceptors.response.use(
  (response) => {
    store.dispatch('loading/finishedRequest');
    return response;
  },
  (error) => {
    store.dispatch('loading/finishedRequest');
    return Promise.reject(error);
  }
);

export { apiClient, apiV2Client, apiFileClient };
